export default __webpack_public_path__ + "static/media/systemAlert.483bb698.png";